/** @jsx jsx */
import { Text } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';
import ProductMedal from '../Product/ProductMedal';
import ProductCategory from '../Product/ProductCategory';
import { graphql } from 'gatsby';

export * from '@bottlebooks/gatsby-theme-event/src/components/ProductCard/ProductCardFeatures';

export default function ProductCardFeatures({ product }) {
  return (
    <Text
      sx={{
        width: '100%',
        display: 'flex',
        gap: 3,
        marginBottom: 2,
        paddingRight: 4,
        order: -1,
      }}
    >
      <ProductMedal product={product} sx={{ marginLeft: -2.5 }} />
      <ProductCategory product={product} sx={{ flex: '1 1 0' }} />
    </Text>
  );
}

export const fragment = graphql`
  fragment BestOfBurgenland_ProductCardFeatures on Bottlebooks_RegisteredProduct {
    ...BestOfBurgenland_ProductMedal
    ...BestOfBurgenland_ProductCategory
  }
`;
